import { render, staticRenderFns } from "./UpperIntermediateCourse.vue?vue&type=template&id=280c6644"
import script from "./UpperIntermediateCourse.vue?vue&type=script&lang=js"
export * from "./UpperIntermediateCourse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports